let offlineMessageElement: HTMLDivElement | null;

let messageDone = false;
// let currentVersion = '';

function rbbMaintenanceHandler(): void {
  fetch('https://tools.rbb-online.de/tools-service/api/maintenances')
    .then(response => response.json())
    .then((response) => {
      let maintenance;
      let offline = false;
      for (const message of response) {
        if (window.location.href.match(message.urlRegex)) {
          maintenance ??= message;
          if (maintenance.offline) {
            offline = true;
          }
        }
      }

      if (offline) {
        if (!offlineMessageElement) {
          offlineMessageElement = document.createElement('div');
          offlineMessageElement.style.position = 'fixed';
          offlineMessageElement.style.top = '0';
          offlineMessageElement.style.left = '0';
          offlineMessageElement.style.right = '0';
          offlineMessageElement.style.bottom = '0';
          offlineMessageElement.style.zIndex = '1200';
          offlineMessageElement.style.backgroundColor = 'var(--bs-body-bg)';
          offlineMessageElement.ariaModal = 'true';
          offlineMessageElement.innerHTML
            = '<div style="font-size: 80px; line-height: 0.93; letter-spacing: -0.02em; width: 50%; margin: 15% 25% 0; transform: rotate(-4deg); -ms-transform: rotate(-4deg); font-family: \'rbb V2 Interstate Condensed\', sans-serif; font-weight: 900; color: #e31818;" role="alertdialog">\n'
              + '    Wartungsarbeiten<br><span style="font-size: 40px;">Die Seite kann zurzeit nicht genutzt werden. Diese Meldung verschwindet wieder, wenn die Wartung abgeschlossen ist.</span>\n'
              + '</div>';
          document.body.insertBefore(offlineMessageElement, null);
          document.body.style.overflow = 'hidden';
        }
      } else {
        if (offlineMessageElement) {
          offlineMessageElement.remove();
          document.body.style.overflow = '';
        }
      }

      if (maintenance && !messageDone) {
        if (maintenance.redirect) {
          if (maintenance.redirect === '--maintenance.html--') {
            window.location.replace(`${import.meta.env.VITE_DEPLOYMENT_URL}/errors/maintenance.html`);
          } else {
            window.location.replace(maintenance.redirect);
          }
          return;
        }

        let title = 'Wartung';
        if (maintenance.type === 'INFO') {
          title = 'Information';
        }
        if (maintenance.type === 'UPDATE') {
          title = 'Update';
        }

        const maintenanceMessage = document.createElement('div');
        maintenanceMessage.innerHTML
          = '<div class="toast d-none d-sm-block" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="true" data-bs-delay="30000" style="position: fixed; top: 62px; right: 10px; z-index: 1055;">'
            + '<div class="toast-header">'
            + '<i class="fa-solid fa-info-circle me-1"></i>'
            + '<strong class="me-auto">' + title + '</strong>'
            + '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>'
            + '</div>'
            + '<div class="toast-body">' + maintenance.message + '</div>'
            + '</div>';
        document.body.insertBefore(maintenanceMessage, null);
        const maintenanceMessageObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            // noinspection JSUnresolvedVariable
            if (mutation.attributeName === 'class' && (mutation.target as HTMLElement)?.classList?.contains('hide') && document.body.contains(maintenanceMessage)) {
              document.body.removeChild(maintenanceMessage);
            }
          });
        });
        maintenanceMessageObserver.observe(maintenanceMessage, { subtree: true, attributes: true });
      }

      messageDone = true;
    });

  /*
  if (currentVersion) {
    fetch('assets/web-version.json?t=' + Date.now())
      .then(response => response.json())
      .then(response => {
        if (response.version && currentVersion !== response.version) {
          currentVersion = '';
          const versionMessage = document.createElement('div');
          versionMessage.innerHTML =
            '<div class="toast d-none d-sm-block" role="alert" aria-live="assertive" aria-atomic="true" data-bs-autohide="false"\n     ' +
            'style="position: fixed; top: 62px; right: 10px; z-index: 1055;">\n    ' +
            '<div class="toast-header">' +
            '<i class="fa-solid fa-info-circle me-1"></i>' +
            '<strong class="me-auto">Neue Version</strong>\n        ' +
            '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>\n    ' +
            '</div>\n    ' +
            '<div class="toast-body">\n        <div class="mb-2">' +
            'Für diese Webseite steht eine neue Version zur Verfügung. Bitte aktualisieren Sie die Webseite.</div>\n        ' +
            '<button id="websiteReload" class="btn btn-sm btn-primary">Webseite neuladen</button>\n    ' +
            '</div>\n' +
            '</div>';
          document.body.insertBefore(versionMessage, null);
          versionMessage.querySelector('button#websiteReload').addEventListener('click', () => window.location.href = window.location.origin + window.location.pathname + '?t=' + Date.now());
          const versionMessageObserver = new MutationObserver(mutations => {
            mutations.forEach((mutation) => {
              if (mutation.attributeName === 'class' && mutation.target.classList.contains('hide') && document.body.contains(versionMessage)) {
                document.body.removeChild(versionMessage);
              }
            });
          });
          versionMessageObserver.observe(versionMessage, {subtree: true, attributes: true});
        }
      });
  }
  */
}

document.addEventListener('DOMContentLoaded', () => {
  /* const metaNoVersionCheckTag = document.querySelector('meta[name="no-version-check"]');
  if (!metaNoVersionCheckTag || metaNoVersionCheckTag.getAttribute('content') === 'false') {
    const metaVersionTag = document.querySelector('meta[name="version"]');
    if (metaVersionTag) {
      currentVersion = metaVersionTag.getAttribute('content');
    }
  } */
  rbbMaintenanceHandler();
  setInterval(rbbMaintenanceHandler, 300000);
});
